
import { supabase } from '@/lib/supabase';
import { toast } from 'sonner';
import { deleteFileFromStorage, getPathFromUrl } from '@/lib/api/paper-storage';
import { adminError } from '@/lib/utils/admin-logger';
import { Paper } from '@/types/paper';

/**
 * Deletes a paper completely, including all versions, files, reviews, and comments
 * @param paperId ID of the paper to delete
 * @returns Promise resolving to true if deletion was successful
 */
export const deletePaper = async (paperId: string): Promise<boolean> => {
  try {
    // First, clean up storage files for all versions
    const { data: versions } = await supabase
      .from('paper_versions')
      .select('file_url')
      .eq('paper_id', paperId);
      
    if (versions) {
      for (const version of versions) {
        if (version.file_url && 
            version.file_url.trim() !== '' && 
            !version.file_url.includes('undefined')) {
          const filePath = getPathFromUrl(version.file_url);
          if (filePath) {
            await deleteFileFromStorage(filePath);
          }
        }
      }
    }

    const { error } = await supabase.rpc('admin_delete_paper', { 
      paper_id: paperId 
    });
    
    if (error) {
      adminError('Error in admin_delete_paper RPC:', error);
      throw error;
    }

    toast.success('Paper has been completely removed');
    return true;
    
  } catch (error) {
    adminError('Error deleting paper:', error);
    toast.error('Failed to delete paper', {
      description: error instanceof Error ? error.message : 'Please try again or contact support'
    });
    return false;
  }
};
